<template>
  <div class="section-category">
    <div class="section-pay mx-auto">
      <h2 class="ttl-pay text-center" v-translate>PAY</h2>
      <div class="form-row">
        <div class="col-12">
          <div
            v-if="
              payType.indexNumber >= amountPayType.indexNumber
              && ( payType.name != 'invoice' || isPayInvoice)"
            v-for="payType in payTypes"
            class="form-group row line pb-2" >
            <div
              class="ttl col-7 pay-type" >
              <span>{{ payType.name }}</span>
              <span v-if="payType.value && payType.value != 0">
                ({{ payType.value }}%)
              </span>
            </div>
            <div
              v-if="(payType.value && payType.value != 0)
                      || isSpecialPayType(payType.name)"
              class="col-5 txt-r pay-ttl" >
              <strong>{{ getPayDetail(payType).total | currency }}</strong>
            </div>
            <div
              v-else
              class="col-5 txt-r pay-ttl" >
              <input-pad
                :item="getPayDetail(payType)"
                :property="'total'"
                :maxLength="10"
                :usingDecimal="usingDecimal"
                :attributes="{'class': 'payment'}"/>
            </div>
          </div>
        </div>
        <div class="button-footer">
          <button type="button" class="btn btn-primary" @click="closeBill" v-translate>Close</button>
          <router-link :to="{name: 'order'}" class="btn btn-default" v-translate>Cancel</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { SET_MESSAGE_MODAL } from "@/store/mutation-types";
export default {
  name: 'Pay',
  data() {
    return {
      specialPayTypes: ['subtotal', 'total', 'amount', 'change']
    };
  },
  computed: {
    payTypes() {
      return this
              .getArray('payTypes')
              .sort((a, b) => a.indexNumber > b.indexNumber ? 1 : -1)
    },
    amountPayType() {
      return this.getObject('amount', 'payTypes', 'name');
    },
    currentInputPad() { return this.getMap('currentInputPad', true) },
    bill() { return this.getMap('bill', true) },
    ...mapGetters(['totalAmount', 'getPayDetail', 'isPayInvoice']),
    usingDecimal() { return this.$store.state.auth.currency.decimalType }
  },
  methods: {
    isSpecialPayType(payType) {
      return this.specialPayTypes.indexOf(payType) != -1;
    },
    async closeBill() {
      const changePayType = this.getObject('change', 'payTypes', 'name');
      const change = this.getPayDetail(changePayType);
      if(change && change.total >= 0) {
        this
          .$store
          .dispatch(
            'closeBill',
            {
              id: this.bill.id,
              payDetails: this.bill.payDetails
            }
          );
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Amount not paid in full'));
      }
    },
  },
  mounted() {
    if(!this.bill.id) this.$router.replace({ name: 'order' });
  },
  watch: {
    currentInputPad(value) {
      if(value.item) {
        const invoicePayType = this.getObject('invoice', 'payTypes', 'name');
        if(value.item.payType == invoicePayType.id) {
          const otherPayTypes = this
                                  .getArray('payTypes')
                                  .filter(payType =>
                                    payType.indexNumber > this.AMOUNT_PAYTYPE
                                    && payType.indexNumber < this.CHANGE_PAYTYPE
                                    && payType.indexNumber != this.INVOICE_PAYTYPE
                                  );
          otherPayTypes.forEach(payType => {
            const payDetail = this.getPayDetail(payType);
            payDetail.total = 0;
          });
          const amountPayType = this.getObject('amount', 'payTypes', 'name');
          const amount = this.getPayDetail(amountPayType);
          value.item.total = Math.abs(amount.total);
        } else {
          const invoice = this.getPayDetail(invoicePayType);
          invoice.total = 0;
        }
      }
    }
  }
};
</script>
